import { useCallback, useState } from 'react';
import type { WorkspaceSearchFull } from '@/types';
import {
  SearchResultsAllContext, SearchResultsDispatchContext, SearchResultsFileContext,
  SearchResultsFolderContext, SearchResultsResetContext,
} from './Context';
import type { SearchResultsContextState } from './interfaces';

export default function Results({ children }: ChildrenProps) {
  const [state, dispatch] = useState<SearchResultsContextState>(getInitialState());

  const reset = useCallback((_: WorkspaceSearchFull.SearchTab) => {
    // dispatch(prev => ({
    //   ...prev,
    //   [tab]: tab === 'all'
    //     ? {
    //       brands: null,
    //       projects: null,
    //       members: null,
    //       files: null,
    //       folders: null,
    //       transcripts: null,
    //     }
    //     : null,
    // }));
    dispatch(getInitialState());
  }, []);

  return (
    <SearchResultsDispatchContext.Provider value={dispatch}>
      <SearchResultsResetContext.Provider value={reset}>
        <SearchResultsAllContext.Provider value={state.all}>
          <SearchResultsFileContext.Provider value={state.files}>
            <SearchResultsFolderContext.Provider value={state.folders}>
              {children}
            </SearchResultsFolderContext.Provider>
          </SearchResultsFileContext.Provider>
        </SearchResultsAllContext.Provider>
      </SearchResultsResetContext.Provider>
    </SearchResultsDispatchContext.Provider>
  );
}

function getInitialState(): SearchResultsContextState {
  return {
    all: {
      files: null,
      folders: null,
    },
    files: null,
    folders: null,
  };
}

export { Results };